import * as React from 'react';
import { connect } from 'react-redux';
import Lightbox from '../Lightbox';
import Store from '../../../common/models/Store';
import { setRegionalDisplayedSessionCookie } from '../../../helpers/cookie';
import RegionalLightboxContent from './RegionalLightboxContent';

import { Desktop, Mobile } from '../../MediaQuery';

/* Interfaces */
interface RegionalLightboxProps {
  basePathWeb: string;
  close: () => void;
  countryId: number;
  s3BasePath: string;
}

/* Helpers */
const mapStateToProps = ({ api: { basePathWeb, countryId, s3BasePath } }: Store) => ({
  basePathWeb,
  countryId,
  s3BasePath,
});

class RegionalLightbox extends React.Component<RegionalLightboxProps> {
  componentDidMount() {
    const { basePathWeb } = this.props;
    setRegionalDisplayedSessionCookie(basePathWeb);
  }

  render() {
    const { close } = this.props;
    return (
      <Lightbox close={close}>
        <Desktop>
          <RegionalLightboxContent {...this.props} />
        </Desktop>
        <Mobile>
          <RegionalLightboxContent wrapperBackground="black" {...this.props} />
        </Mobile>
      </Lightbox>
    );
  }
}

export default connect(mapStateToProps)(RegionalLightbox);
